import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { Col, Row } from "react-bootstrap";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import AddProductInOrder from './AddProductInOrder'; 
import {useDispatch} from 'react-redux';
 
import { CreateAutomaticOrder } from "../../../redux/slices/inventory/inventory.thunks";


const initialState = {
    Items: null,
    ItemIds: null,
    Order: {
        State: "pending",
        Comment: "",
        OrderedAt: new Date(),
        Deadline: new Date()
    }
}

/**
 *
 * @param order {initialState}
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
export default function FormOrdering({
    title,
    show,
    onClose,
    onSubmit,
    order,
    onChange,
    isLoading = false,
    confirmBtnText
}) {


    const [data, setData] = useState(order ?? initialState)
    
    const dispatch = useDispatch();

    const handleClosing = () => onClose && onClose() && setData(initialState)

    const XLSX = require('xlsx'); 
        const handleSubmit = () => {
        const callback = () => {
            //toast.success('n')
            //handleClosing()
        };

        var OrderItemArray = []

        data.Items.forEach((element, i) => {
            OrderItemArray.push({
                'LINE_NO': i+1,
                'CODE' : element.VendorsOrderInfo['0AupBbm4r6Vd0anrzXg1'].ItemInfo.CODE,
                'DESIGNATION': element.Name,
                'QUANTITE': element.Quantity

            })
        });


        const createData = {
            NameVendor: "Abibou",
            VendorId: '0AupBbm4r6Vd0anrzXg1',
            vendorEmail: "alabi93abibou@gmail.com",
            OrderItem: JSON.parse(JSON.stringify(OrderItemArray))
        }

        console.log("Me DATA IN Form = "+ JSON.stringify(createData));
        console.log("Me DATA IN FORMATE = "+ JSON.stringify(OrderItemArray));

        
        dispatch(CreateAutomaticOrder(createData, callback))
    }
    
    const handleChange = (change) => {
        onChange && onChange(change)
        setData(change)
    }

    const handleItemListChange = (items) => handleChange({ ...data, Items: items, ItemIds: items.map(item => item.Id), Quantityes: items.map(item => item.Quantity) })
    // console.log("sfsffdg ", data.Quantityes)
    // console.log("GoodDays ", data.Items)
    // console.log("******* ", order)
    // console.log("----------- ", JSON.stringify(data))
    // console.log("----------- ", data)
    // console.log("QuantityToBuy", JSON.stringify(data.Items[0].Quantity))

    return (
        <>
            <Dialog open={show} onClose={handleClosing} maxWidth='lg' fullWidth centered="true" >

                <DialogTitle >
                    <Row >
                        <Col className='col-auto text-truncate' >
                            {title}
                        </Col>
                        <Col className='col-auto ml-auto'>
                            <IconButton onClick={handleClosing}>
                                <CloseIcon />
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>

                <DialogContent>

                    <AddProductInOrder items={data.Items} onChange={handleItemListChange} />



                </DialogContent>

                <DialogActions>

                    <Button variant='contained' color='primary' onClick={handleSubmit} disabled={isLoading} centered="true" >
                        {confirmBtnText ?? 'Envoyer'}
                    </Button>
                    <Button variant='contained' color='primary' onClick={handleSubmit} disabled={isLoading} centered="true" >
                        {confirmBtnText ?? 'Export'}
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    )

}
